export default __webpack_public_path__ + "static/icon-25-3-342afdbf32f7604a033f307e2ce4bb86.png";